import {
  NgModule,
} from '@angular/core';
import {
  RouterModule,
} from '@angular/router';
import {
  JourneysStoreModule,
} from '@des/store/journeys';
import {
  CancelCheckInEligibleGuard,
} from './cancel-check-in-eligible';

@NgModule({
  imports: [JourneysStoreModule, RouterModule],
  providers: [CancelCheckInEligibleGuard]
})
export class CancelCheckInEligibleGuardModule {}
